import { createActionNamespace } from 'Modules/core/redux';

import { GetDocs, SetError, SetLoading, UpdateDocs } from './types';


const documentsAction = createActionNamespace('docs');

export const documentsActions = {
    getDocs: documentsAction<GetDocs>('GET_DOCS'),
    setLoading: documentsAction<SetLoading>('SET_DOCUMENTS_LOADING'),
    setError: documentsAction<SetError>('SET_DOCUMENTS_ERROR'),
    setDocs: documentsAction<UpdateDocs>('SET_DOCS'),
};
